module.exports = __webpack_public_path__ + "static/media/marvelous_01.ba169632.jpg";